import { 
    Modal, 
    ModalOverlay, 
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Text,
} from "@chakra-ui/react";


const WalletInstructionModal = ({ open, setOpen }: any) => {

    return (
        <Modal 
        onOverlayClick={() => setOpen(false)}
        isCentered isOpen={open} 
        onClose={() => null} size="md" scrollBehavior="inside">
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Wallet Instructions</ModalHeader>
                <ModalCloseButton onClick={() => setOpen(false)}/>
            <ModalBody>
                <Text fontWeight='bold' mb='1rem'>
                  Terra Station
                </Text>
                <p>
                    <span style={{ fontWeight: 'bold' }}>If you have Terra Station Installed:</span>
                    <br/>
                    First, recover / make a new wallet and make sure you have enough balance. 
                    Then press Connect on the Top Right of Navigation or below, to see your Terra Station Options.
                    Click Terra Station to connect via Chrome Extension, or click Wallet Connect to connect via Mobile.
                    <br/>
                    <span style={{ fontWeight: 'bold' }}>If you don't have Terra Station Installed:</span>
                    <br/>
                    Use <span style={{ color: 'blue', textDecoration: 'underline' }}>
                    <a target="_blank" 
                    href="https://chrome.google.com/webstore/detail/terra-station-wallet/aiifbnbfobpmeekipheeijimdpnlpgpp">this</a>
                    </span> link to install chrome extension on your browser, then follow instructions above. Or use Wallet Connect to connect via mobile.
                </p>
                <Text fontWeight='bold' mb='1rem' mt='1rem'>
                  MetaMask Wallet
                </Text>
                <p>
                    <span style={{ fontWeight: 'bold' }}>If you have MetaMask Installed:</span>
                    <br/>
                    Please proceed with the Metamask Wallet Connection, after you will be able to donate ETH in the MetaMask Wallet. 
                    If you have xDefi Prioritized, then you will need to de-prioritize it before connecting to MetaMask.
                    <br/>
                    <span style={{ fontWeight: 'bold' }}>If you don't have MetaMask Installed:</span>
                    <br/>
                    Use <span style={{ color: 'blue', textDecoration: 'underline' }}>
                    <a target="_blank" 
                    href="https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en">this</a>
                    </span> link to install MetaMask Wallet on your browser, set up according to wallet instructions then follow instructions above.
                </p>
                <Text fontWeight='bold' mb='1rem' mt='1rem'>
                  Binance Wallet
                </Text>
                <p>
                    <span style={{ fontWeight: 'bold' }}>If you have Binance Wallet Installed:</span>
                    <br/>
                    Please proceed with the Binance Wallet Connection, after you will be able to donate BNB in the wallet. 
                    If you have xDefi Prioritized, then you will need to de-prioritize it before connecting to Binance Wallet.
                    <br/>
                    <span style={{ fontWeight: 'bold' }}>If you don't have Binance Wallet Installed:</span>
                    <br/>
                    Use <span style={{ color: 'blue', textDecoration: 'underline' }}>
                    <a target="_blank" 
                    href="https://chrome.google.com/webstore/detail/binance-wallet/fhbohimaelbohpjbbldcngcnapndodjp">this</a>
                    </span> link to install Binance Wallet on your browser, set up according to wallet instructions then follow instructions above.
                </p>
                <Text fontWeight='bold' mb='1rem' mt='1rem'>
                  xDefi Wallet
                </Text>
                <p>
                    <span style={{ fontWeight: 'bold' }}>If you have xDefi Installed:</span>
                    <br/>
                    Make sure you are logged in and have enough balance. If you just want to use Terra Assets 
                    within xDefi Wallet, you may select xDefi option in the Terra Provider without further actions.
                    However, if you want to use ETH inside xDefi,
                    click the hamburger on the top right, and set "Prioritize XDEFI" to true, then when you press
                    Connect Button on the WebApp, you should see the ETH balance ready for use.
                    <br/>
                    <span style={{ fontWeight: 'bold' }}>If you don't have xDefi Installed:</span>
                    <br/>
                    Use <span style={{ color: 'blue', textDecoration: 'underline' }}>
                    <a target="_blank" 
                    href="https://chrome.google.com/webstore/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf">this</a>
                    </span> link to install xDefi Wallet on your browser, then follow instructions above.
                </p>
            </ModalBody>

            </ModalContent>
        </Modal>
    )
}

export default WalletInstructionModal;